<script setup lang="ts">
  import { init } from '@/helpers/responsive'
  import { useUserStore } from '@/store/User'
  import { defineAsyncComponent } from 'vue'
  import { addGnbGaEvents } from './gnb/addGaEvents'
  import { capitalize } from './helpers/converter'
  import { stripLandingUtmContent } from './helpers/utm'
  import { EXPOSURE_GLOBAL_SEARCH } from './helpers/exposures'
  import { useExposureStore } from './store/Exposure'
  import { useGlobalSearchStore } from './store/GlobalSearch'
  import { useOverlayCtaStore } from './store/OverlayCta'
  const OverlayCta = defineAsyncComponent(() => import('./components/Common/OverlayCta.vue'))

  const userStore = useUserStore()
  const route = useRoute()
  const router = useRouter()

  const overlayStore = useOverlayCtaStore()
  const globalSearchStore = useGlobalSearchStore()
  const exposureStore = useExposureStore()

  const seoTitle = computed(() => capitalize(route.meta.seo?.title ?? route.meta.menuTitle ?? ''))

  useHead({
    title: () => seoTitle.value,
    titleTemplate: 'MapleStory | %s',
    meta: [
      {
        name: 'description',
        content: () => route.meta.seo && route.meta.seo.description,
      },
      {
        name: 'keywords',
        content: () => route.meta.seo && route.meta.seo.keywords,
      },
    ],
  })

  watch(
    () => route.meta?.gaPageType,
    (val) => {
      if (val) {
        window.dataLayer.push({
          pageType: val,
        })
      }
    }
  )

  onMounted(async () => {
    window.version = `Maplestory Website Version : ${VITE_APP_VERSION}`
    console.log(window.version)
    userStore.getUserInfo()
    init()
    addGnbGaEvents()
    // Resolves the GNB search icon's visibility; the route guard reuses the same cached lookup.
    exposureStore.resolveExposure(EXPOSURE_GLOBAL_SEARCH)
    // Site-wide: drop `utm_content` from the address bar once GTM has read the landing URL.
    stripLandingUtmContent(router)
  })
</script>
<template>
  <NavigationBar />

  <div class="body">
    <RouterView />
  </div>

  <OverlayCta v-if="overlayStore.state.Children && overlayStore.state.Children.length" />
  <LightBox />
  <ScrollToTopButton />
  <Demo />
</template>

<style lang="scss">
  @media (max-width: 375px) {
    // temporary fixed the GNB for screens smaller than 375px
    #globalNavigation,
    .global-navigation,
    #globalFooter {
      min-width: 100% !important;
    }
  }
</style>
@/config/overlayCta/overlay
